import styled from 'styled-components';
import Carousel from '@carvana/ds-carousel';
import { background, text, body, heading, breakpoint, spacing } from '@carvana/ds-styles';
import Link from '@carvana/ds-link';

const Background = styled.div`
  background-color: ${background.weak};
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 0 ${spacing['4Xl']};
  }
`;

const StyledCarousel = styled(Carousel)`
  margin-top: ${spacing['4Xl']};
  margin-bottom: ${spacing['4Xl']};
  width: 100%;
  box-sizing: border-box;

  @media screen and (min-width: ${breakpoint.lg}) {
    max-width: 1272px;
  }

  .slide > div {
    margin-right: 0;
  }

  .slides,
  .top-section {
    margin-left: ${spacing['2Xl']};
    margin-right: ${spacing['2Xl']};

    @media screen and (min-width: ${breakpoint.lg}) {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

const CarouselHeader = styled.div`
  @media screen and (min-width: ${breakpoint.md}) {
    margin-right: -75px;
  }
`;

const Title = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
`;

const Info = styled.p`
  color: ${text.strong};
  ${body.regular.sm};
  margin: 16px 0 ${spacing['2Xl']} 0;

  @media screen and (min-width: ${breakpoint.sm}) {
    max-width: 522px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    min-width: 650px;
    max-width: 744px;
  }
`;

const RatingContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
`;

const TotalRating = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 4px;
  margin-top: 8px;
`;

export {
  Background,
  StyledCarousel,
  CarouselHeader,
  Info,
  RatingContainer,
  Title,
  StyledLink,
  TotalRating
};
